import { render, staticRenderFns } from "./gallery-widget.vue?vue&type=template&id=9e8845c8&"
import script from "./gallery-widget.vue?vue&type=script&lang=js&"
export * from "./gallery-widget.vue?vue&type=script&lang=js&"
import style0 from "./gallery-widget.vue?vue&type=style&index=0&id=9e8845c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports